import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { CustomFormQrCodeLoading } from "./CustomFormQrCode.loading";
import { CustomFormQrCodeProps } from "./CustomFormQrCode.types";

export const CustomFormQrCodeLoadable = lazy(
  () => import("./CustomFormQrCode")
);

export const CustomFormQrCode = (props: CustomFormQrCodeProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<CustomFormQrCodeLoading />}>
      <CustomFormQrCodeLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
